import { useCallback, ReactNode } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import ContentCopy from '@mui/icons-material/ContentCopyRounded';

interface CopyDebugInfoButtonProps {
  message: string | ReactNode;
  debugInfo?: string;
  sessionId?: string;
  accountId?: string | number;
  timestamp?: number;
  size?: 'small' | 'medium';
  color?: 'inherit' | 'primary' | 'secondary';
  sx?: any;
}

export function CopyDebugInfoButton({
  message,
  debugInfo,
  sessionId,
  accountId,
  timestamp,
  size = 'small',
  color = 'inherit',
  sx,
}: CopyDebugInfoButtonProps) {
  const handleCopy = useCallback(async () => {
    const parts: string[] = [];
    if (typeof message === 'string') parts.push(message);
    if (debugInfo) parts.push(debugInfo);
    if (sessionId) parts.push(`Session ID: ${sessionId}`);
    if (accountId != null) parts.push(`Account ID: ${accountId}`);
    if (timestamp) parts.push(`Time: ${new Date(timestamp).toUTCString()}`);
    const textToCopy = parts.join('; ');

    try {
      await navigator.clipboard.writeText(textToCopy);
    } catch (err) {
      console.error('Failed to copy to clipboard:', err);
    }
  }, [message, debugInfo, sessionId, accountId, timestamp]);

  return (
    <Tooltip title="Copy debug info" arrow>
      <IconButton size={size} color={color} onClick={handleCopy} sx={sx} aria-label="copy debug info">
        <ContentCopy fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
